import { render } from "./toExpendInv.vue?vue&type=template&id=55f92c63&scoped=true"
import script from "./toExpendInv.vue?vue&type=script&lang=js"
export * from "./toExpendInv.vue?vue&type=script&lang=js"

import "./toExpendInv.vue?vue&type=style&index=0&id=55f92c63&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f92c63"]])

export default __exports__